import { ID } from '@griply/types';

// A goal-linked task carries both goalId and taskId; a goal *deadline* marker carries goalId and no taskId.
export const isGoalDeadlineEvent = <
  T extends { goalId?: ID | null; taskId?: ID | null },
>(
  event: T,
): event is T & { goalId: ID } => !!event.goalId && !event.taskId;
